import { useMutation } from "react-query"
import { APIEndpoints } from "../constants/api-endpoints"
import { HttpRequest } from "../services/_http"

interface GenerateLabelsRequest {
  title: string
  description: string
  transcript?: string
  prompt_text?: string
}

interface GenerateLabelsResponse {
  labels: string[]
}

export const useGenerateLabelsFromFile = () => {
  return useMutation(({ file, title, description, prompt_text }: { 
    file: File, 
    title: string, 
    description: string, 
    prompt_text?: string 
  }) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('title', title)
    formData.append('description', description)
    if (prompt_text) {
      formData.append('prompt_text', prompt_text)
    }

    return HttpRequest({
      url: APIEndpoints.GenerateLabelsFromFile,
      method: 'POST',
      data: formData
    })
  })
}

export const useGenerateLabelsFromText = () => {
  return useMutation(({ title, description, prompt_text }: { 
    title: string, 
    description: string, 
    prompt_text?: string 
  }) => {
    return HttpRequest({
      url: APIEndpoints.GenerateLabelsFromText,
      method: 'POST',
      data: {
        title,
        description,
        prompt_text
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
  })
}
